module.exports = __webpack_public_path__ + "media/images/favicon/primary/android-icon-96x96-42a33d40a7ca56cca60f5366910c84ac.png";